import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { AppRoutes } from './constants';
import { PartnerScoreChannel } from '@/pages/PartnerScore/components/TabSwitcher/utils/types';
import { CompetitorAnalysisChannel } from '@/pages/CompetitorAnalysis/components/CompetitorTabSwitcher/utils/types';

export function getTabIdFromPathname(
  pathname: string,
  routeToTabId: Record<string, string>,
  defaultTabId: string,
): string {
  return routeToTabId[pathname] ?? defaultTabId;
}

export const PARTNER_SCORE_PATHNAME_TO_TAB_ID: Record<string, string> = {
  [AppRoutes.PARTNERSCORE]: PartnerScoreChannel.PARTNERSCORE,
  [AppRoutes.CSATSCORE]: PartnerScoreChannel.CSATSCORE,
  [AppRoutes.CESSCORE]: PartnerScoreChannel.CESSCORE,
  [AppRoutes.NPSSCORE]: PartnerScoreChannel.NPSSCORE,
};

export const COMPETITOR_ANALYSIS_PATHNAME_TO_TAB_ID: Record<string, string> = {
  [AppRoutes.COMPETITOR_ANALYSIS]: CompetitorAnalysisChannel.PARTNERSCORE,
  [AppRoutes.COMPETITOR_CSATSCORE]: CompetitorAnalysisChannel.CSATSCORE,
  [AppRoutes.COMPETITOR_CESSCORE]: CompetitorAnalysisChannel.CESSCORE,
  [AppRoutes.COMPETITOR_NPSSCORE]: CompetitorAnalysisChannel.NPSSCORE,
};

export function usePartnerScoreTabIdFromPathname(): string {
  const location = useLocation();
  return useMemo(
    () => getTabIdFromPathname(location.pathname, PARTNER_SCORE_PATHNAME_TO_TAB_ID, PartnerScoreChannel.PARTNERSCORE),
    [location.pathname],
  );
}

export function useCompetitorAnalysisTabIdFromPathname(): string {
  const location = useLocation();
  return useMemo(
    () =>
      getTabIdFromPathname(
        location.pathname,
        COMPETITOR_ANALYSIS_PATHNAME_TO_TAB_ID,
        CompetitorAnalysisChannel.PARTNERSCORE,
      ),
    [location.pathname],
  );
}
